import { callable } from '../callable';
import { usePortalViewStore } from '../../stores/portal-view.store';
import type { PortalView } from '../portal-view';

// «Ver portal»: abre la vista de solo lectura (academicsDispatch). El servidor
// comprueba el cargo, que sea alumno y que no figure como fallecido, y deja la
// apertura en la auditoría ANTES de crear la vista.

export const portalViewApi = {
  open: async (data: { tenantId: string; personId: string }): Promise<PortalView> => {
    const fn = callable<
      typeof data,
      { viewId: string; personId: string; studentCode: string | null; expiresAt: string }
    >('openPortalView');
    const r = (await fn(data)).data;
    // Atada a quien la abre: con otra sesión en la pestaña, la vista no existe.
    return {
      ...r,
      tenantId: data.tenantId,
      viewerUid: usePortalViewStore.getState().sessionUid ?? '',
    };
  },
};
